import { CharacterTypes } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';

interface BuiltInBulletConfig {
    char: string;
    fontFamily: string;
    backup: {
        char: string;
        fontFamily: string;
    }
}

// 默认 backup 字体
const backupFontFamily = '"Arial","sans-serif"';
const builtInBulletsConfigMap = {
    [CharacterTypes.ITEMSYMBOL_CIRCLE]: {
        char: 'l',
        fontFamily: 'Wingdings',
        backup: {
            char: '●',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_SQUARE]: {
        char: 'n',
        fontFamily: 'Wingdings',
        backup: {
            char: '■',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_RHOMBUS]: {
        char: 'u',
        fontFamily: 'Wingdings',
        backup: {
            char: '◆',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_STAR]: {
        char: '✧',
        fontFamily: 'Zapf Dingbats',
        backup: {
            char: '✧',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_CHECK]: {
        char: 'ü',
        fontFamily: 'Wingdings',
        backup: {
            char: '✓',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_ARROW]: {
        char: 'Ø',
        fontFamily: 'Wingdings',
        backup: {
            char: '➢',
            fontFamily: backupFontFamily,
        },
    },
    [CharacterTypes.ITEMSYMBOL_SMALL_CIRCLE]: {
        char: '•',
        fontFamily: 'Arial',
        backup: {
            char: '•',
            fontFamily: backupFontFamily,
        },
    },
};
const builtInBulletsConfig: Array<BuiltInBulletConfig> = [
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_CIRCLE],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_SQUARE],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_RHOMBUS],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_STAR],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_CHECK],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_ARROW],
    builtInBulletsConfigMap[CharacterTypes.ITEMSYMBOL_SMALL_CIRCLE],
    {
        // 这个不是 slide 内置项目符号，是 ppt 的内置项目符号
        char: 'p',
        fontFamily: 'Wingdings',
        backup: {
            char: '□',
            fontFamily: backupFontFamily,
        },
    },
];

export function getBuiltInBulletConfig(char = '', fontFamily = ''): BuiltInBulletConfig | undefined {
    return builtInBulletsConfig.find(item => item.char === char && item.fontFamily === fontFamily);
}

/**
 * 根据项目编号类型获取对应的配置
 * @param type
 * @returns
 */
export function getBuiltInBulletConfigByType(type: string): BuiltInBulletConfig | undefined {
    return builtInBulletsConfigMap[type];
}
